module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fc-Ga-Ha-Ia-Ga.6a61fc58.png";